import BaseMap from '../../BaseMap.jsx'
import usePluginSwap from '../../plugins/usePluginSwap.jsx'
import useHotkeys from './useHotkeys.mjs'
import useReadMap from './useReadMap.mjs'
import useMindMapPlugins from './useMindMapPlugins.mjs'
import usePermission from './usePermission.mjs'
import LeftPanel from './LeftPanel.jsx'
import usePluginIsrf from './usePluginIsrf.jsx'
import ToolBar from './ToolBar/ToolBar.jsx'

const components = {LeftPanel, ToolBar}

export default function ProductMap({id, permission, type, ...props}) {
    const readMap = useReadMap(id, type)
    const hotkeys = useHotkeys()

    const plugins = [
        useMindMapPlugins(),
        usePermission(permission),
        usePluginSwap(),
        usePluginIsrf(),
    ]

    return (
        <BaseMap
            components={components}
            hotkeys={hotkeys}
            permission={permission}
            plugins={plugins}
            readMap={readMap}
            {...props}
        />
    )
}
